import React from "react";

// Item 193: per-type skeleton loaders shown while a widget's data is loading.
const bar = "rounded bg-[color:var(--surface-2)]";

function KpiSkeleton() {
  return (
    <div className="h-full w-full flex flex-col justify-center gap-2.5 px-4 animate-pulse">
      <div className={`${bar} h-3 w-1/3`} />
      <div className={`${bar} h-8 w-3/5`} />
      <div className={`${bar} h-2.5 w-2/5`} />
    </div>
  );
}

function PieSkeleton() {
  return (
    <div className="h-full w-full flex items-center justify-center animate-pulse">
      <div className="rounded-full bg-[color:var(--surface-2)] w-[55%] max-w-[140px] aspect-square" />
    </div>
  );
}

function BarsSkeleton() {
  const hs = [55, 80, 40, 92, 65, 30, 74];
  return (
    <div className="h-full w-full flex items-end gap-[6%] px-5 pb-5 pt-4 animate-pulse">
      {hs.map((h, i) => (
        <div key={i} className={`${bar} flex-1`} style={{ height: `${h}%` }} />
      ))}
    </div>
  );
}

function LineSkeleton() {
  return (
    <div className="h-full w-full px-4 py-4 animate-pulse">
      <svg viewBox="0 0 100 40" preserveAspectRatio="none" className="w-full h-full">
        <path d="M0 32 Q12 12 25 22 T50 16 T75 26 T100 8" fill="none" strokeWidth="3"
          className="stroke-[color:var(--surface-2)]" strokeLinecap="round" />
      </svg>
    </div>
  );
}

function TableSkeleton() {
  return (
    <div className="h-full w-full flex flex-col gap-1.5 p-3 animate-pulse overflow-hidden">
      <div className={`${bar} h-5 w-full opacity-90`} />
      {Array.from({ length: 6 }, (_, i) => (
        <div key={i} className="flex gap-2">
          <div className={`${bar} h-3.5 flex-[2]`} />
          <div className={`${bar} h-3.5 flex-1`} />
          <div className={`${bar} h-3.5 flex-1`} />
        </div>
      ))}
    </div>
  );
}

function MapSkeleton() {
  return (
    <div className="h-full w-full p-3 animate-pulse">
      <div className={`${bar} h-full w-full relative overflow-hidden`}>
        <div className="absolute left-1/4 top-1/3 w-3 h-3 rounded-full bg-[color:var(--surface)]" />
        <div className="absolute left-1/2 top-1/2 w-3 h-3 rounded-full bg-[color:var(--surface)]" />
        <div className="absolute left-2/3 top-1/4 w-3 h-3 rounded-full bg-[color:var(--surface)]" />
      </div>
    </div>
  );
}

const PIE_TYPES = ["pie", "donut", "semi_donut", "gauge", "liquidfill", "radar", "sunburst"];
const TABLE_TYPES = ["table", "pivot", "data_grid"];
const MAP_TYPES = ["geo_map", "bubble_map", "point_map"];
const LINE_TYPES = ["line", "area", "scatter", "candlestick", "calendar_heatmap"];

export function WidgetSkeleton({ type }) {
  let body;
  if (type === "kpi") body = <KpiSkeleton />;
  else if (PIE_TYPES.includes(type)) body = <PieSkeleton />;
  else if (TABLE_TYPES.includes(type)) body = <TableSkeleton />;
  else if (MAP_TYPES.includes(type)) body = <MapSkeleton />;
  else if (LINE_TYPES.includes(type)) body = <LineSkeleton />;
  else body = <BarsSkeleton />;
  return <div data-testid="widget-skeleton" className="h-full w-full">{body}</div>;
}
